const applyMaster = {
  name: 'applyMaster',
  path: 'applyMaster',
  component: resolve => require(['../../components/pages/applyMaster'], resolve),
  redirect: 'applyMaster/enroll/sign',
  children: [{
    path: 'enroll/sign',
    component: resolve => require(['../../components/pages/applyMaster/enroll/sign'], resolve)
  }, {
    path: 'enroll/signResult',
    component: resolve => require(['../../components/pages/applyMaster/enroll/sign/Result'], resolve)
  }, {
    path: 'enroll/signEdit',
    component: resolve => require(['../../components/pages/applyMaster/enroll/signEdit'], resolve)
  }, {
    path: 'enroll/signEditResult',
    component: resolve => require(['../../components/pages/applyMaster/enroll/signEdit/Result'], resolve)
  }, {
    path: 'query/writeDetail',
    component: resolve => require(['../../components/pages/applyMaster/query/writeDetail'], resolve)
  }, {
    path: 'query/interviewDetail',
    component: resolve => require(['../../components/pages/applyMaster/query/interviewDetail'], resolve)
  }, {
    path: 'query/admission',
    component: resolve => require(['../../components/pages/applyMaster/query/admission'], resolve)
  }, {
    path: 'special',
    component: resolve => require(['../../components/pages/applyMaster/special'], resolve)
  }, {
    path: 'intendCity',
    component: resolve => require(['../../components/pages/applyMaster/intendCity'], resolve)
  }]
}

export default applyMaster



// WEBPACK FOOTER //
// ./src/router/pages/applyMaster.js